<template>

    <section>

        <p style="text-align: center; margin-bottom: 1rem;">通常のページネーション</p>
        <!-- 通常のページネーション ここから -->

            <div class="md_pagination">
                <div class="link">
                    <a class="chevron _previous" href=""><span></span></a>
                    <a href=""><span>6</span></a>
                    <a href=""><span>7</span></a>
                    <a href="" class="_current"><span>8</span></a>
                    <a href=""><span>9</span></a>
                    <a href=""><span>10</span></a>
                    <a class="chevron _next" href=""><span></span></a>
                </div>
                <div class="control">
                    <span>8 / 11</span>
                </div>
            </div>
        <!-- 通常のページネーション ここまで -->

        <p style="text-align: center; margin-top: 4rem; margin-bottom: 1rem;">セレクトボックスタイプ</p>
        <!-- セレクトボックスタイプ ここから -->

            <div class="md_pagination">
                <div class="link">
                    <!-- SelectItem -->
                    <div>Page</div>
                    <div class="item form_select">
                        <div class="input-row">
                            <select name="" id="">
                                <option value="">1</option>
                                <option value="">2</option>
                                <option value="">3</option>
                                <option value="">4</option>
                                <option value="">5</option>
                                <option value="">6</option>
                                <option value="">7</option>
                                <option value="">8</option>
                                <option value="">9</option>
                                <option value="">10</option>
                                <option value="">11</option>
                            </select>
                        </div>
                    </div>
                    <div> / 11</div>
                </div>
            </div>
        <!-- セレクトボックスタイプ ここまで -->

    </section>

</template>


<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import EditorJS from '@editorjs/editorjs'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            // "layout": AdminLayout,
            //Svg
            SvgIconCheck,
        },
        data() {
            return {
                status: '',
                destination: '',
                title: '',
                text: '',
                pulldown_status: [
                    { id: 0, name: '非公開' },
                    { id: 1, name: '公開' },
                    { id: 2, name: '下書き' },
                ],
                pulldown_destination: [
                    { id: 0, name: '全体' },
                    { id: 1, name: 'ショップ' },
                    { id: 2, name: 'ブランド' },
                ],
                news_id: 0, //0の場合は新規追加
                editor: {},
                page_title: 'admin - お知らせ新規作成＆編集画面',
            }
        },
        props: {
            news: Array,
        },
        mounted() {
            if (this.news) {
                this.news_id = this.news.id;
                this.destination = this.news.recipient;
                this.title = this.news.title;
                this.text = this.news.text;
                switch (this.news.recipient) {
                    case 0:
                        this.destination = '全体';
                        break;
                    case 1:
                        this.destination = 'ブランド';
                        break;
                    case 2:
                        this.destination = 'ショップ';
                        break;
                }
                switch (this.news.status) {
                    case 0:
                        this.status = '非公開';
                        break;
                    case 1:
                        this.status = '公開';
                        break;
                    case 2:
                        this.status = '下書き';
                        break;
                }
            }
            this.doEditor()
        },
        methods: {
            doEditor() {
                const savedData = this.text ? JSON.parse(this.text) : null
                this.editor = new EditorJS({
                    holder: 'codex-editor',
                    minHeight: 50,
                    placeholder: 'No content',
                    data: savedData,
                })
            },
            newsPost() {
                this.editor.save().then((outputData) => {
                    if (outputData.blocks.length) {
                        const form = reactive({
                            id: this.news_id,
                            status: this.status,
                            destination: this.destination,
                            title: this.title,
                            text: JSON.stringify(outputData),
                        })
                        Inertia.post('/admin/news/register', form, {
                            onStart: (visit) => {
                                this.page_title = '送信中・・・'
                            },
                            onError: (errors) => {
                                if (errors.text) {
                                    window.alert(errors.text);
                                }
                            },
                            onProgress: (progress) => {
                                // this.page_title = '送信中・・・'
                            },
                            onSuccess: (page) => {
                                this.status = '';
                                this.destination = '';
                                this.title = '';
                                this.text = '';
                                this.editor = {};
                                outputData = '';
                                alert('登録が完了しました')
                            },
                        })
                    } else {
                        window.alert('お知らせ詳細を入力してください');
                    }
                }).catch((error) => {
                    console.log('Saving failed: ', error)
                });
            },
        }
    }
</script>
